<template>
<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-color-organization`]" width="1em" height="1em" v-bind="$attrs"><path d="M4.8125 16.4795C5.84812 16.4795 6.6875 17.319 6.6875 18.3545C6.68729 19.3898 5.84799 20.2295 4.8125 20.2295C3.77701 20.2295 2.93771 19.3898 2.9375 18.3545C2.9375 17.319 3.77688 16.4795 4.8125 16.4795ZM12 16.4795C13.0356 16.4795 13.875 17.319 13.875 18.3545C13.8747 19.3898 13.0355 20.2295 12 20.2295C10.9645 20.2295 10.1253 19.3898 10.125 18.3545C10.125 17.319 10.9644 16.4795 12 16.4795ZM19.1875 16.4795C20.2231 16.4795 21.0625 17.319 21.0625 18.3545C21.0623 19.3898 20.223 20.2295 19.1875 20.2295C18.152 20.2295 17.3127 19.3898 17.3125 18.3545C17.3125 17.319 18.1519 16.4795 19.1875 16.4795ZM12 2.75C13.1283 2.75003 14.043 3.66473 14.043 4.79297C14.043 5.92123 13.1283 6.83591 12 6.83594C10.8716 6.83594 9.95703 5.92125 9.95703 4.79297C9.95705 3.66471 10.8716 2.75 12 2.75Z" :fill="useCurrentColor ? 'currentColor' : '#165DFF'"/><path d="M12 8.03125L12 14.2225" stroke="#00BBD8" stroke-width="1.663" stroke-linejoin="round"/><path d="M4.8125 14.2225V11.2473H19.1875V14.2225" stroke="#00BBD8" stroke-width="1.663"/></svg>
</template>
<script>

export default {
  name: 'IconColorOrganization',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
